var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"cookie-settings-link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.open.apply(null, arguments)}}},[_vm._v("Cookie settings")])}
var staticRenderFns = []

export { render, staticRenderFns }